import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import CardResults from '../CardResults/CardResults';
import FeaturePromo from '../FeaturePromo/FeaturePromo';
import { ShareBox } from '../ReadingFooter/ReadingFooter';
import { readingCopy } from '../../data/readingCopy';
import './ReadingModal.css';

const ReadingModal = ({ cards, verdict, interpretation, isStreaming, onClose, onAskAnother, lang }) => {
  const copy = readingCopy(lang);
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return createPortal(
    <div className="rm-overlay" onClick={onClose}>
      <div className="rm-modal" onClick={(e) => e.stopPropagation()}>
        <button className="rm-close" onClick={onClose} aria-label={copy.close}>✕</button>
        <h2 className="rm-title">{copy.modalTitle}</h2>

        <CardResults
          cards={cards}
          verdict={verdict}
          interpretation={interpretation}
          isStreaming={isStreaming}
          lang={lang}
          hideShare
        />

        {interpretation && !isStreaming && (
          <button className="rm-again-btn" onClick={onAskAnother}>
            {copy.askAnother}
          </button>
        )}

        <FeaturePromo variant="modal" lang={lang || 'en'} />
        {interpretation && !isStreaming && <ShareBox lang={lang} />}
      </div>
    </div>,
    document.body
  );
};

export default ReadingModal;
